import React from "react";
import SectionReveal from "./SectionReveal";

const CLIENT_LOGOS = [
  {
    id: "hnoc",
    name: "The Historic New Orleans Collection",
    src: `${process.env.PUBLIC_URL}/logos/hnoc.png`,
  },
  {
    id: "ochsner",
    name: "Ochsner Health",
    src: `${process.env.PUBLIC_URL}/logos/ochsner-health.png`,
  },
  {
    id: "imperva",
    name: "Imperva, a Thales company",
    src: `${process.env.PUBLIC_URL}/logos/imperva.png`,
  },
  {
    id: "fps",
    name: "FutureProof Sales",
    src: `${process.env.PUBLIC_URL}/logos/fps.png`,
  },
  {
    id: "smithsonian",
    name: "Smithsonian Institution",
    src: `${process.env.PUBLIC_URL}/logos/smithsonian.png`,
  },
];

const Clients = () => {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative bg-[#050505] py-20 sm:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <SectionReveal>
          <h3
            className="text-xs font-bold uppercase tracking-[0.3em] text-zinc-500 text-center mb-14"
            data-testid="clients-heading"
          >
            — Some of our happy clients —
          </h3>
        </SectionReveal>

        <SectionReveal delay={0.1}>
          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 items-center gap-10 sm:gap-12"
            data-testid="clients-grid"
          >
            {CLIENT_LOGOS.map((logo) => (
              <div
                key={logo.id}
                className="flex items-center justify-center h-24 sm:h-28"
                data-testid={`client-logo-${logo.id}`}
              >
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="client-logo max-h-full max-w-full object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default Clients;
